import auth0 from 'auth0-js'
import EventEmitter from 'eventemitter3'
import { router } from '../main'
import jwt from  'jsonwebtoken'
import axios from 'axios'

export default class AuthService {
  authenticated = this.isAuthenticated()
  authNotifier = new EventEmitter()

  constructor () {
    this.login = this.login.bind(this)
    this.setSession = this.setSession.bind(this)
    this.logout = this.logout.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
  }

  auth0 = new auth0.WebAuth({
    domain: 'stokedskills.auth0.com',
    clientID: 'yNtX1AqXCjyy3xU5c2wKYwVjtOTAAlTt',
    redirectUri: window.location.origin + "/angelinvestor/callback",
    audience: 'https://stokedskills.auth0.com/userinfo',
    responseType: 'token id_token',
    scope: 'openid profile email'
  })

  login () {
    this.auth0.authorize()
  }

  async handleAuthentication () {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult).then(()=> {
          router.replace('profile/' + (localStorage.getItem("userHash") || ""))
        })
      } else if (err) {
        router.replace('leaderboard')
        // eslint-disable-next-line
        console.log(err)
        alert(`Error: ${err.error}. Check the console for further details.`)
      }
    })
  }

  async setSession (authResult) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    )
    localStorage.setItem('access_token', authResult.accessToken)
    localStorage.setItem('id_token', authResult.idToken)
    localStorage.setItem('expires_at', expiresAt)

    let payload = jwt.decode(authResult.idToken);
    
    localStorage.setItem("email", payload.email);
    
    try { 
      let response = await axios.get(`https://7vrdif15wa.execute-api.us-east-1.amazonaws.com/dev/getuserhash?token=${authResult.idToken}`);
      if(response && response.data && response.data.userHash) {
        debugger;
        localStorage.setItem("userHash", response.data.userHash);
      }
    } catch (e) {
      console.log("Unable to find user in db. Must have not played game yet. ")
    }

    this.authNotifier.emit('authChange', { authenticated: true })
  }

  logout () {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')

    localStorage.removeItem("email");
    localStorage.removeItem("userHash");


    this.userProfile = null
    this.authNotifier.emit('authChange', false)
    // navigate to the home route
    router.replace('leaderboard')
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    return new Date().getTime() < expiresAt
  }
}